import { motion } from 'framer-motion'
import { 
  MessageCircle, 
  Mail, 
  FileText, 
  Calendar, 
  TrendingUp, 
  Users,
  Clock,
  CheckCircle,
  BarChart3,
  Download
} from 'lucide-react'
import ActivityLog from './ActivityLog'

const StatsSection = ({ stats, onTabChange }) => {
  const statCards = [
    {
      label: 'Chat Aktive',
      value: stats.activeChats,
      icon: MessageCircle,
      color: 'from-green-500 to-emerald-600',
      change: '+12%'
    },
    {
      label: 'Mesazhe Sot',
      value: stats.todayMessages,
      icon: TrendingUp,
      color: 'from-blue-500 to-cyan-600',
      change: '+8%'
    },
    {
      label: 'Kontakte',
      value: stats.contactForms,
      icon: Mail,
      color: 'from-purple-500 to-pink-600',
      change: '+15%'
    },
    {
      label: 'Aplikacione',
      value: stats.applications,
      icon: FileText,
      color: 'from-orange-500 to-red-600',
      change: '+5%'
    },
    {
      label: 'Konsultime',
      value: stats.consultations,
      icon: Calendar,
      color: 'from-yellow-500 to-orange-600',
      change: '+10%'
    },
    {
      label: 'Vizitorë Online',
      value: stats.visitors || 0,
      icon: Users,
      color: 'from-teal-500 to-green-600',
      change: 'Live'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-3xl font-display font-bold text-gradient-gold mb-2">
          Statistika e Përgjithshme
        </h2>
        <p className="text-beige-300">Përmbledhje e aktivitetit të sotëm</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {statCards.map((stat, index) => {
          const Icon = stat.icon
          return (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-bronze-900/30 backdrop-blur-sm border border-gold-500/20 rounded-2xl p-6 hover:border-gold-500/40 transition-all"
            >
              <div className="flex items-start justify-between mb-4">
                <div className={`w-12 h-12 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center shadow-lg`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <span className="text-xs font-medium text-green-400 bg-green-400/10 px-2 py-1 rounded-full">
                  {stat.change}
                </span>
              </div>
              <div>
                <p className="text-beige-400 text-sm mb-1">{stat.label}</p>
                <p className="text-4xl font-display font-bold text-cream">{stat.value}</p>
              </div>
            </motion.div>
          )
        })}
      </div>

      {/* Recent Activity - Real Data */}
      <ActivityLog maxItems={8} />

      {/* Quick Actions */}
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-gradient-to-br from-gold-500/20 to-bronze-500/20 border border-gold-500/30 rounded-2xl p-6">
          <h3 className="text-lg font-display font-bold text-gold-400 mb-3">
            Veprime të Shpejta
          </h3>
          <div className="space-y-2">
            <button 
              onClick={() => onTabChange('chat')}
              className="w-full btn-primary text-sm justify-center hover:scale-105 transition-transform"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              Shiko të gjitha chat-et
            </button>
            <button 
              onClick={() => onTabChange('export')}
              className="w-full btn-secondary text-sm justify-center hover:scale-105 transition-transform"
            >
              <Download className="w-4 h-4 mr-2" />
              Eksporto Raportin
            </button>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-blue-500/30 rounded-2xl p-6">
          <h3 className="text-lg font-display font-bold text-blue-400 mb-3">
            Performanca
          </h3>
          <div className="space-y-2 text-sm text-beige-200">
            <div className="flex justify-between">
              <span>Kohë mesatare përgjigje</span>
              <span className="font-semibold">2.5 min</span>
            </div>
            <div className="flex justify-between">
              <span>Shkallë kënaqësie</span>
              <span className="font-semibold text-green-400">98%</span>
            </div>
            <div className="flex justify-between">
              <span>Konvertime</span>
              <span className="font-semibold text-gold-400">45%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatsSection
